import 'twin.macro';

import { navigate } from '@reach/router';
import IconCost from 'assets/svg/icons/cost.inline.svg';
import ContentFit from 'components/Atoms/ContentFit';
import Comment from 'components/Organisms/Comment';
import PanelLimit from 'components/Organisms/PanelLimit';
import PanelSelect from 'components/Organisms/PanelSelect';
import SubHeader from 'components/Organisms/SubHeader';
import SEO from 'components/SEO';
import { routes } from 'constants/routes';
import HeaderContext from 'providers/HeaderProvider';
import React, { useContext, useEffect, useRef } from 'react';

export default function index() {
	const { setHeader } = useContext(HeaderContext);
	const refContainer = useRef();

	useEffect(() => {
		setHeader({ isMain: false, isSelect: false, isLimit: false });
	}, []);

	return (
		<div ref={refContainer} className='flex flex-col items-center justify-between'>
			<SEO
				title='Indywidualna wycena kosztów faktoringu. Faktoring krajowy i zagraniczny 100% online'
				keywords='kredyt obrotowy kalkulator, koszt faktoringu, koszty faktoringu, faktoring koszt, faktoring koszty, faktoring krajowy, faktoring eksportowy, kredyt walutowy, kredyt walutowy dla firm'
				description='Ty decydujesz ile płacisz. Sprawdź nasze ceny. Oferta dopasowana. 100% online. Niezależnie od tego czy sprzedajesz na rynek krajowy czy zagraniczny - potrzebujesz płynności. Smart Faktor to sprawdzony partner i nowa jakość w faktoringu. Oferta Limit, oferta Selekt'
			/>

			<SubHeader Icon={IconCost} title='Kalkulator oferty faktoringowej' iconSize='1.6rem' />

			<ContentFit siblingHeight='4.5rem'>
				<div className='panel-wrapper px-20 portrait:px-20 flex-4/1'>
					<PanelSelect onClick={() => navigate(routes.SELECT_FORM)} />
					<PanelLimit onClick={() => navigate(routes.LIMIT_FORM)} />
				</div>

				<Comment className='mb-10' primary title='Przygotowanie oferty zajmie 10 sekund.' withBg />
			</ContentFit>
		</div>
	);
}
